import { Match, Show, Switch, createEffect } from "solid-js";
import { createProjectSubmissionInputs } from "./form";
import { submission_status, team, update_team } from "./apis";
import { solidstate } from ":setup/qstate";
import { global } from ":shared/app";
import { Loader2 } from ":src/components/loaders";
// import { downloadFile } from ":shared/helpers/methods";

export default function ProjectSubmission(props: { onRouteToCreateTeam: () => void }) {
  // $image_max().values?.value is image size maximum in MB
  const $image_max = global.store.hooks.platform.useSettings("image_max");
  const $pdf_max = global.store.hooks.platform.useSettings("pdf_max");
  const settings = global.store.actions.platform.getProjectSubmission();
  const tracks = global.store.actions.platform.getTracks();

  const FormInputs = createProjectSubmissionInputs({
    image_max: $image_max().values?.value,
    pdf_max: $pdf_max().values?.value,
  });
  const $submission_status = solidstate.createAsync(submission_status.get);
  const $submission_details = solidstate.createAsync(team.get);
  const $can_update = solidstate.create(false);
  const $loading = solidstate.create(false);
  // FormInputs.Track?.control?.markDisabled(true);
  const char_limit = 500;

  createEffect(() => {
    if ($submission_status.state.success) {
      if ($submission_status.unwrap.value?.submission) {
        $can_update.set(true);
        if ($submission_details.state.success) {
          if ($submission_details?.unwrap?.value?.team == undefined) {
            return;
          }
          // TODO: fix this shit with typescript
          // @ts-ignore
          FormInputs.Actions.update($submission_details?.unwrap?.value?.team);
          // console.log("submission_details.unwrap.value?.team:: ", $submission_details.unwrap.value?.team);
        }
      }
    }
  });

  const onSubmit = async (e: Event) => {
    e.preventDefault();
    $loading.set(true);
    try {
      const values = FormInputs.Actions.getValuesSnakecase();

      const { presentation, project_cover, project_images, ...filteredValues } = values;
      const payload = {
        ...filteredValues,
        project_images: FormInputs?.ProjectImages?.control?.value?.[0],
        presentation: FormInputs?.Presentation?.control?.value?.[0],
        project_cover: FormInputs?.ProjectCover?.control?.value?.[0],
      };
      console.log("values:: ", values);
      await update_team.put(payload);
      global.store.actions.toast.pushToast({
        type: "success",
        message: "Project Submitted Successfully!",
      });
      $loading.set(false);
    } catch (error: any) {
      $loading.set(false);
    }
  };

  return (
    <section class="flex flex-col w-full h-full overflow-y-auto overflow-x-hidden sm:(px-5 py-4) <sm:(px-3 py-2)">
      <div class="flex flex-row w-fit items-center xs:(space-x-2) <xs:(flex-wrap)">
        <h1 class="w-full  text-xl font-[600] text-black <sm:(text-22px) xs:(whitespace-nowrap)">Project Submission</h1>
        <a
          href={settings.submission?.url}
          download
          target="_blank"
          class="flex flex-row w-fit h-fit bg-bg-button text-text-button whitespace-nowrap text-center cursor-pointer py0.5 px1 text-0.5rem rounded-1 no-underline"
        >
          Instructions PDF
        </a>
      </div>
      <Switch>
        <Match when={$submission_details.state.loading}>
          <Loader2 msg="Loading Submission Details..." />
        </Match>
        <Match when={$submission_details.state.failed}>
          an error occurred while fetching {$submission_details.error}
        </Match>

        <Match when={!$can_update.value}>
          <div class="w-50% h-full flex flex-col justify-center gap-4 items-center self-center <sm:(w-full)">
            <h2 class="font-bold text-1rem  text-center  <sm:(w-full text-0.8rem)">
              You can not submit project because you are not in a team or your team members did not reach the minimum of{" "}
              {settings.team_min.value} members.
            </h2>
            <div class="w-full flex justify-center items-center ">
              <button
                class="form-btn"
                onClick={() => {
                  props?.onRouteToCreateTeam?.();
                }}
              >
                Create Team
              </button>
            </div>
          </div>
        </Match>
        <Match when={$submission_details.state.success}>
          <form class="grid grid-cols-[50%_50%] w-full h-fit gap-y-3 gap-x-2 pt-6 <sm:(grid-cols-1 py-5 gap-y-2 !gap-x-0)">
            <FormInputs.TeamName.Label title="Team Name" class="form-label ">
              <FormInputs.TeamName.Input
                autocomplete="Team Name"
                type="text"
                class="form-input"
                placeholder={`Enter Team Name`}
              />
            </FormInputs.TeamName.Label>

            <FormInputs.Track.Label title="Team Track" class="form-label">
              <FormInputs.Track.Select
                class="form-select"
                options={tracks.values}
                onNoOptions={() => {
                  console.warn("no track options to select from");
                  global.store.actions.toast.pushToast({
                    type: "error",
                    message: "Tracks list was not provided by admin!",
                  });
                }}
              />
            </FormInputs.Track.Label>

            <FormInputs.ProjectName.Label title="Project Name" class="form-label">
              <FormInputs.ProjectName.Input
                autocomplete="Project Name"
                type="text"
                class="form-input"
                placeholder={`Enter Project Name`}
              />
            </FormInputs.ProjectName.Label>

            <FormInputs.ProjectVideo.Label title="Project Video" class="form-label">
              <FormInputs.ProjectVideo.Input
                autocomplete="Project Video"
                type="text"
                class="form-input "
                placeholder="https://..."
              />
            </FormInputs.ProjectVideo.Label>

            <FormInputs.ProblemStatement.Label title="Problem Statement" class="form-label">
              <FormInputs.ProblemStatement.TextArea
                autocomplete="Problem_Statement"
                class="form-textarea"
                placeholder="Write a brief about the problem"
                maxlength={char_limit}
              />
            </FormInputs.ProblemStatement.Label>

            <FormInputs.ResearchProcess.Label title="Research Process" class="form-label">
              <FormInputs.ResearchProcess.TextArea
                autocomplete="Research_Process"
                class="form-textarea"
                placeholder="Write a brief about the problem"
                maxlength={char_limit}
              />
            </FormInputs.ResearchProcess.Label>

            <FormInputs.Ideation.Label title="Ideation" class="form-label">
              <FormInputs.Ideation.TextArea
                autocomplete="Ideation"
                class="form-textarea"
                placeholder="Write a brief about the idea with its objectives "
                maxlength={char_limit}
              />
            </FormInputs.Ideation.Label>

            <FormInputs.ApplicableSolution.Label title="Applicable Solution" class="form-label">
              <FormInputs.ApplicableSolution.TextArea
                autocomplete="Applicable_Solution"
                class="form-textarea"
                placeholder="Write a brief about the problem"
                maxlength={char_limit}
              />
            </FormInputs.ApplicableSolution.Label>

            <FormInputs.Feasibility.Label title="Solution Feasibility" class="form-label">
              <FormInputs.Feasibility.TextArea
                autocomplete="Solution Feasibility"
                class="form-textarea"
                placeholder="Write a brief about the Feasibility Solution"
                maxlength={char_limit}
              />
            </FormInputs.Feasibility.Label>

            <FormInputs.BusinessModel.Label title="Business Model" class="form-label">
              <FormInputs.BusinessModel.TextArea
                autocomplete="Business_Model"
                class="form-textarea"
                placeholder="Write a brief about the problem"
                maxlength={char_limit}
              />
            </FormInputs.BusinessModel.Label>

            <FormInputs.Impact.Label title="Project Impact" class="form-label">
              <FormInputs.Impact.TextArea
                autocomplete="Project Impact"
                class="form-textarea"
                placeholder="Write a brief about The impacts of your project "
                maxlength={char_limit}
              />
            </FormInputs.Impact.Label>

            <FormInputs.ProjectCover.Label title="Project Cover" class="form-label">
              <FormInputs.ProjectCover.InputFile
                placeholder="/images/profile_image_template.png"
                accept="image/*"
                class="form-input-file taller"
                elements={{
                  overlay({ onclick, viewer_data, drag }) {
                    return (
                      <div
                        onclick={onclick}
                        class="flex flex-col w-full h-full justify-center items-center gap-5px cursor-pointer"
                      >
                        <p class="cursor-pointer">
                          <Show when={!drag} fallback={"Drop Files"}>
                            <span class="underline text-16px">
                              Upload .PNG, JPG, JPEG file, less than {FormInputs.$$META.image_max} MB
                            </span>
                          </Show>
                        </p>
                        <Show when={viewer_data.file}>{viewer_data.file.name}</Show>
                      </div>
                    );
                  },
                }}
              />
            </FormInputs.ProjectCover.Label>

            <FormInputs.ProjectImages.Label
              title="Project Images"
              class="form-label"
              note={$submission_details.value?.image}
            >
              <FormInputs.ProjectImages.InputFile
                accept=".pdf"
                class="form-input-file"
                elements={{
                  overlay({ onclick, viewer_data, drag }) {
                    return (
                      <div
                        onclick={onclick}
                        class="flex flex-col w-full h-full justify-center items-center gap-5px cursor-pointer"
                      >
                        <p class="cursor-pointer">
                          <Show when={!drag} fallback={"Drop Files"}>
                            <span class="underline text-16px">
                              Upload .PDF file, less than {FormInputs.$$META.pdf_max} MB
                            </span>
                          </Show>
                        </p>
                        <Show when={viewer_data.file}>{viewer_data.file.name}</Show>
                      </div>
                    );
                  },
                }}
              />
            </FormInputs.ProjectImages.Label>

            <FormInputs.Presentation.Label
              title="Project Presentation"
              class="form-label"
              note={$submission_details.value?.presentation}
            >
              <FormInputs.Presentation.InputFile
                accept=".pdf"
                class="form-input-file"
                elements={{
                  overlay({ onclick, viewer_data, drag }) {
                    return (
                      <div
                        onclick={onclick}
                        class="flex flex-col w-full h-full justify-center items-center gap-5px cursor-pointer"
                      >
                        <p class="cursor-pointer">
                          <Show when={!drag} fallback={"Drop Files"}>
                            <span class="underline text-16px">
                              Upload .PDF file, less than {FormInputs.$$META.pdf_max} MB
                            </span>
                          </Show>
                        </p>
                        <Show when={viewer_data.file}>{viewer_data.file.name}</Show>
                      </div>
                    );
                  },
                }}
              />
            </FormInputs.Presentation.Label>

            {/* submit btn */}
            <div class="flex flex-col self-end justify-end items-end sm:col-span-2">
              <FormInputs.Actions.Button
                class="form-btn md:!w-30%"
                onclick={(e) => {
                  global.store.actions.popop.pushConfirmDialog({
                    type: "warn",
                    message: "Are you sure you want to submit this project?",
                    events: {
                      onConfirmed() {
                        onSubmit(e);
                      },
                    },
                  });
                }}
                statusValid="Submit Project"
                statusInvalid="Submit Project"
                statusSubmit="Submitting Project..."
              />
            </div>
          </form>
        </Match>
      </Switch>
    </section>
  );
}
